import { AccountService } from "core/service";
import { AccountPersistence } from "core/persistence";
import BaseRepository from "core/repository/base.repository";

class AccountRepository extends BaseRepository {
  syncable = false;

  getEntityIdentifier() {
    return "account";
  }

  resourceName() {
    return "contas";
  }

  getServiceProvider() {
    return AccountService;
  }

  getPersistenceProvider() {
    return AccountPersistence;
  }

  async createAccount(params) {
    return this.mService.createAccount({
      ...params,
      origin: process.env.REACT_APP_API_ORIGIN
    });
  }

  async changePassword(params) {
    return this.mService.changePassword(params);
  }
}

export default new AccountRepository();



// WEBPACK FOOTER //
// ./src/core/repository/account.repository.js